export interface removeItem {
    key: string;
    linesInTotalAfterKey?: number;
    exactMatch?: boolean;
    toBeRemovedAfter?: string;
}